import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector   : 'fuse-confirm-dialog',
    templateUrl: './confirm-dialog2.component.html',
    styleUrls  : ['./confirm-dialog2.component.scss']
})
export class FuseConfirmDialog2Component
{
    public confirmMessage: string;

    constructor(public dialogRef: MatDialogRef<FuseConfirmDialog2Component>)
    {
    }

}
